export const SET_SWITCH_WIDGET_SELECTION = 'SET_SWITCH_WIDGET_SELECTION';

export default {
    SET_SWITCH_WIDGET_SELECTION,
};
